import { useQuery } from 'react-query'
import formatNumber from '../../../helpers/formatNumber'
import type { SimpleVehicleProps } from '../../../types/types'
import { fetchLatestServiceInvoice } from '../../../../../../../api/newApi'
import { formatDate } from '../../../helpers/formatDate'
import type React from 'react'
import { PrimaryButton } from '../../../_shared/Buttons/PrimaryButton'
import { useMediaQuery } from '../../../../../v3/hooks/useMediaQuery'
import { formatSimulatedMileage } from '../../../helpers/formatTableValues'

type CarParkExpandedRowProps = {
  car: SimpleVehicleProps
  user: any
  company: any
  openInfo?: (car: SimpleVehicleProps) => void
}

export const expandedTableLabels = [
  'Samlefaktura',
  'Fakturagruppe',
  'Biltype',
  'Kontaktperson',
  'Budsjett nr.',
  'Drivstoff',
  'KM-simulert',
  'Kmstand',
  'Siste servicefakt.',
  'Estimert leveringsdato',
]
export const mobileExpandedTableLabels = ['', 'Kontaktperson']

const CarParkExpandedRow = ({ car, user, company, openInfo }: CarParkExpandedRowProps) => {
  const isDesktop = useMediaQuery('(min-width: 768px)')

  const { data: serviceInvoice, isLoading: serviceInvoiceIsLoading } = useQuery({
    queryKey: ['servicefakt', car?.registrationNumber],
    queryFn: async () => {
      if (!car || !company?.id || !user?.id) return null
      if (!car.accountNo && !car.budgetNo) return null

      return await fetchLatestServiceInvoice(company.id, car.accountNo || car.budgetNo, user.id)
    },
    enabled: !!car && (!!car.accountNo || !!car.budgetNo),
  })

  const serviceInvoiceStatus = !serviceInvoiceIsLoading
    ? serviceInvoice?.[0]
      ? formatDate(serviceInvoice[0].date)
      : '-'
    : 'laster...'

  const deliveryDate = car?.deliveryDate ? new Date(car?.deliveryDate).toLocaleString('no-NO').split(',')?.[0] : '-'

  const openModalCarInfo = () => {
    return <PrimaryButton onClick={() => openInfo?.(car)}>Bilinformasjon</PrimaryButton>
  }

  const expandedData: (string | number | undefined | React.ReactNode | null)[] = [
    car.consolidatedInvoiceCode,
    car.invoiceGroup,
    car.vehicleType,
    car.mainContactName,
    car.budgetNo,
    car.fuel,
    formatSimulatedMileage(car.simulatedMileage, car.contractMileage),
    car.mileage ? `${formatNumber(car.mileage)} km` : '-',
    serviceInvoiceStatus,
    ...(car?.deliveryDate ? [deliveryDate] : []),
  ]
  const mobileExpandedData: (string | number | undefined | React.ReactNode | null)[] = [
    openModalCarInfo(),
    car.mainContactName,
  ]

  if (!isDesktop) {
    return (
      <>
        {mobileExpandedData.map((value, i) => (
          <td key={i} className="px-4 py-2 text-left align-top">
            <div className="flex flex-col">
              <span className="text-xs text-content-secondary text-nowrap">{mobileExpandedTableLabels[i]}</span>
              <span className="text-sm text-nowrap">{value || '-'}</span>
            </div>
          </td>
        ))}
      </>
    )
  }

  return (
    <>
      {expandedData.map((value, i) => (
        <td key={i} className="px-4 py-2 text-left align-top">
          <div className="flex flex-col">
            <span className="text-xs text-content-secondary text-nowrap">{expandedTableLabels[i]}</span>
            <span className="text-sm text-nowrap">{value || '-'}</span>
          </div>
        </td>
      ))}
    </>
  )
}

export default CarParkExpandedRow
